import { get } from 'lodash';

export const getComponentData = state => state.componentData;

export const getComponentValue = ({ state, key, fallback }) =>
  get(getComponentData(state), key, fallback);
